import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lm-bottomview',
  templateUrl: './bottomview.component.html',
  styleUrls: ['./bottomview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomViewComponent implements OnInit {
  @Input() extraClass = '';
  ngOnInit(): void {}
}
